// Footer.jsx
import React from "react";
import "../../styles/Footer.css";
import img1 from "../../assets/footer/Greenply.jpeg";
import img2 from "../../assets/footer/century.png";
import img3 from "../../assets/footer/sharon.png";
import img4 from "../../assets/footer/shylanply.jpg";
import footerLogo from "../../assets/icity_logo.png";

const logos = [
  { src: img1, alt: "Greenply" },
  { src: img2, alt: "Century" },
  { src: img3, alt: "Sharon" },
  { src: img4, alt: "Shylanply" },
  { src: img1, alt: "Greenply" },  // repeat for smooth scroll
  { src: img2, alt: "Century" },
  { src: img3, alt: "Sharon" },
  { src: img4, alt: "Shylanply" },
];

const Footer = () => {
  return (
    <footer className="ft-wrap" role="contentinfo">
      {/* Scrolling Partner Logos */}
      <div className="ft-partners">
        <div className="logo-scroll">
          <div className="logo-track">
            {logos.map((l, i) => (
              <div className="logo-item" key={i}>
                <img src={l.src} alt={l.alt} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main footer remains unchanged */}
      <div className="ft-main">
        <div className="ft-container ft-grid">
          <div className="ft-brand">
            {/* Updated: Image logo instead of text */}
            <div className="ft-logo">
              <img
                src={footerLogo}
                alt="iCity Woodworks Logo"
                style={{ maxHeight: "50px", width: "auto" }}
              />
            </div>
            <p className="ft-desc">
              Crafting exceptional custom woodwork for over 20 years. From furniture to cabinetry, we bring vision to life with unmatched quality and attention to detail.
            </p>




          </div>

          <nav className="ft-col" aria-labelledby="ft-ql">
            <h3 id="ft-ql" className="ft-col-title">Quick Links</h3>
            <ul className="ft-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Our Services</a></li>
              <li><a href="#portfolio">Gallery</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </nav>


          <nav className="ft-col" aria-labelledby="ft-sv">
            <h3 id="ft-sv" className="ft-col-title">Services</h3>
            <ul className="ft-links">
              <li><a href="#">Custom Furniture</a></li>
              <li><a href="#">Kitchen Cabinetry</a></li>
              <li><a href="#">Built‑in Solutions</a></li>
              <li><a href="#">Finishing services</a></li>
            </ul>
          </nav>

          <div className="ft-col">
            <h3 className="ft-col-title">Contact Us</h3>
            <ul className="ft-links">
              <li>
                <i className="bi bi-envelope"></i>{"  "}
                <a className="ft-mail" href="mailto:woodworks@icityinc.in">
                  woodworks@icityinc.in
                </a>
              </li>
              <li>
                <i className="bi bi-telephone"></i> +91 72000 73335
              </li>
            </ul>

            <div className="ft-social" aria-label="Social links">
              <a
                href="https://www.facebook.com/share/17dQJaXPW7/"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-facebook"></i>
              </a>

              <a
                href="https://www.instagram.com/icity_wood_interiors?igsh=YzljYTk1ODg3Zg=="
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </div>

        </div>

        <div className="ft-container ft-bottom">
          <p className="ft-copy">© 2024 city woodworks. All rights reserved.</p>
          <p className="ft-credit">Designed by <strong>icity Technologies</strong></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
